module.exports = __webpack_public_path__ + "img/banner_02.a91b5e23.jpg";